module.exports = __webpack_public_path__ + "static/media/ug.856cff89.svg";